import { TopicAppearanceApi, topicsApi } from "api";
import { useTopic } from "api/hooks";
import { routes } from "consts";
import React from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { TopicForm, TopicFormValues } from "./TopicForm/TopicForm";
import { TanTableClient, TanTableColumn } from "components/molecules";
import { timeToMinutes } from "utils";
import { useToaster } from "utils";
import { HeaderWithBreadcrumbs, PageMain } from "components/molecules";
import { useTopicAppearances } from "api/hooks/useTopicAppearances";
import { PaziaBox } from "components/atoms";

export const TopicEditPage = (): JSX.Element | null => {
  const { topicId } = useParams();
  const navigate = useNavigate();
  const { showSuccess } = useToaster();
  const { loading, data } = useTopic(Number(topicId));

  if (loading || data === null) return null;

  const breadcrumbs = [{ title: "Tematy", path: routes.TOPICS }, { title: data.title }];

  const onSubmit = async (data: TopicFormValues) => {
    const { time, ...request } = data;

    await topicsApi.update(Number(topicId), { ...request, time: timeToMinutes(time) });
    navigate(routes.TOPICS);
    showSuccess("Temat został zaktualizowany");
  };

  return (
    <PageMain>
      <HeaderWithBreadcrumbs breadcrumbs={breadcrumbs} headerText="Edytuj temat" />
      <PaziaBox>
        <TopicForm topic={data} onSubmit={onSubmit} />
      </PaziaBox>
      {!loading && <TopicAppearances topicId={Number(topicId)} />}
    </PageMain>
  );
};

const TopicAppearances = ({ topicId }: { topicId: number }) => {
  const { isLoading, appearances } = useTopicAppearances(topicId);
  return (
    <PaziaBox header="Wystąpienia w kursach" className="mt-2 md:mt-6">
      <TanTableClient hideBorder data={appearances.course ?? []} columns={columns} pageSize={5} />
    </PaziaBox>
  );
};
const columns: TanTableColumn<TopicAppearanceApi>[] = [
  {
    id: "courseId",
    hideOnMobile: true,
    header: "ID kursu",
    accessorKey: "courseId",
    size: 10,
    enableColumnFilter: false,
  },
  {
    id: "courseName",
    header: "Nazwa",
    accessorKey: "courseName",
    size: 500,
    enableColumnFilter: false,
  },
  {
    id: "groupName",
    hideOnMobile: true,
    header: "W grupie",
    accessorKey: "groupName",
    size: 200,
    enableColumnFilter: false,
  },
  {
    id: "view",
    header: "",
    accessorKey: "courseId",
    enableColumnFilter: false,
    cell: (info) => (
      <Link target="_blank" to={routes.COURSES_EDIT_NESTED.SCHEDULE(info.getValue<number>())}>
        Zobacz
      </Link>
    ),
  },
];
